const COLUMN_RANGES = [
  ['B', 1, 15],
  ['I', 16, 30],
  ['N', 31, 45],
  ['G', 46, 60],
  ['O', 61, 75],
]

const uniqueRandomInRange = (min, max, count) => {
  const pool = []
  for (let n = min; n <= max; n++) pool.push(n)
  for (let i = pool.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[pool[i], pool[j]] = [pool[j], pool[i]]
  }
  return pool.slice(0, count)
}

export const BINGO_LETTERS = COLUMN_RANGES.map(([letter]) => letter)

// A 5x5 grid of booleans matching a card's shape, all unmarked.
export const createEmptyMarks = () =>
  Array.from({ length: 5 }, () => new Array(5).fill(false))

// Returns a 5x5 grid (rows of 5), with the center cell as 'FREE'.
export const generateBingoCard = () => {
  const columns = COLUMN_RANGES.map(([, min, max]) =>
    uniqueRandomInRange(min, max, 5),
  )
  const rows = []
  for (let r = 0; r < 5; r++) {
    rows.push(
      columns.map((col, c) => (c === 2 && r === 2 ? 'FREE' : col[r])),
    )
  }
  return rows
}
